<template>
  <div>
    <homen></homen>
    <div class="pagerc">
        <div class="headerimg">
            <img class="pcshow" src="../assets/images/rc.jpg" alt="">
            <img class="mshow" src="../assets/images/mrc.png" alt="">
            <div class="title">
              <div class="titlep">
                <h3>MEETING AGENDA</h3>
                <h4>大会日程</h4>
              </div>
            </div>
        </div>
        <div class="inchild clear">
          <div class="wrapleft">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="Nov 12th" name="first">
                <div class="media">
                    <h2>Pre-workshop</h2>
                    <ul>
                      <li class="noimg">
                        <div class="nov12 nov12en">
                          <p><b>Context:</b></p>
                          <div class="space spaceen">
                            <div>
                              <p><b> · </b>What’s an Assessment Center</p>
                              <p><b> · </b>The fundamental and history of Assessment Center</p>
                              <p><b> · </b>The design and implementation of Assessment Center</p>
                              <p><b> · </b>The integration and use of Assessment Center Data</p>
                            </div>
                            <div>
                              <p><b> · </b>The future of Assessment Center</p>
                              <p><b> · </b>The interpretation of reports and feedbacks of Assessment Center</p>
                              <p><b> · </b>What you should not miss in the next three days</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <h3>Morning: 9:00 am - 12:30 pm（ Including Lunch )</h3>
                      <li>
                        <div class="media-object pcshow">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/BruceWatt.png" alt="">
                          </div>
                        </div>
                        <div class="media-body nov12">
                          <p><b>09:00-12:30</b></p>
                          <p><b>Speaker:</b>Bruce Watt, Ph.D. | Vice President of DDI</p>
                          <p><b>Bio:</b>Bruce joined DDI in 2000. In his current role as vice president for DDI Europe, India, Australia, DDI licensee operations, and DDI's Global Centre for Excellence, he works with the leadership teams of these regions and functions to ensure the quality practice and sustainable, profitable growth of their operations.</p>
                          <p>As an expert on a broad range of leadership practices, Dr. Watt provides business-relevant counsel to a diverse range of both multinational and regional organizations, identifying needs and proposing solutions primarily in the areas of leadership development and succession management.</p>
                        </div>
                      </li>
                      <h3>Afternoon: 13:30 pm - 17:00 pm</h3>
                      <li>
                        <div class="media-object pcshow">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Billy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body nov12">
                          <p><b>09:00-12:30</b></p>
                          <p><b>Speaker:</b>Billy Sun, Senior Product Manager</p>
                          <p><b>Bio:</b>Mr. Billy Sun oversees Assessment Center for DDI in Greater China Region. His major focus is to design, implement and promote Assessment Center for DDI clients, introducing and localize latest assessment technologies to better sever organizations in China.</p>
                          <p>Mr. Sun is also committed to the quality management of DDI Assessment Center, and development of DDI Executive Assessors.</p>
                        </div>
                      </li>
                    </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Nov 13th" name="second">
                <div class="media">
                  <h2>Antemeridian of  November 13th</h2>
                  <h3>Keynote Session</h3>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/lbx.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>09:00 - 09:20</b></p>
                        <p><b>Opening Remarks</b></p>
                        <p><b>Amanda Lu,</b> Managing Director, DDI East China</p>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>9:20 – 10:00</b></p>
                        <p><b>Topic: </b>21st Century Assessment Centers: A Diferent Approach to the Valid Assessment of Competen-
cies and to Providing Meaningful Feedback to Assessees at Signifcantly Less Time and Cost</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=36"><b>William C. Byham, Ph.D.,</b> Co-Founder and Executive Chairman, DDI</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>Early in the 21st Century, DDI introduced a radically new, cost-effective way of identifying leadership talent, diagnosing leadership development needs, and getting assessee's started on an efficient and effective leadership learning path. Since that time hundreds of thousand people have gone through various versions of DDI’s 21st Century Assessment Centers. William C. Byham will describe how a 21st Century Assessment Center operates: 
                          <b>· </b>There are new and very different ways to assess behaviorally defined competencies.
                          <br><b>· </b>It is possible to assess the behaviors that make up a competency.
                          <br><b>· </b>Human assessor judgments can be made more reliable.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/sharif.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>10:00 - 10:40 </b></p>
                        <p><b>Topic: </b>HR and Microsoft Culture Change</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=83">Sharif Khan, GEO HR GM for Microsoft, Asia</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>Over the past few years, Microsoft has been undergoing continuous transformation led by CEO Satya Nadella. Microsoft's human resources department is also changing, with corporate culture taking the brunt of this change: 
                          <br><b>· </b>Why we chose to evolve.
                          <br><b>· </b>Our culture, defined.
                          <br><b>· </b>Our model for culture change. 
                          <br><b>· </b>Measuring the current state of culture.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/gjd.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>10:40 - 11:20</b></p>
                        <p><b>Topic: </b>Organizational Capabilities and Leadership Development in Digital Industrial Era</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=90"><b>Jiandang Gu,</b> Executive Committee Member of Phoenix Contact Group,
President of Phoenix Contact (China) Holding Co., Ltd.</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>In the digital age, what changes should be made to the strategic logic, organizational capability and leadership of enterprises? Phoenix Contact, a family business from Germany, chooses "looking at the present from the future”, to change the organizational form, activate the organization, motivate individuals, driven by customer value. It connects reliable people and things, establishes a coordinated, open, symbiotic and win-win ecosystem, and continues to evolve and grow in the current of the times.
                          <br><b>· </b>The key to organizational transformation in the future.
                          <br><b>· </b>Leadership and entrepreneurship in the digital industry era. 
                          <br><b>· </b>Create a shared and symbiotic ecosystem and lead the new future of the digital industry.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/lzm.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>11:20 - 12:00</b></p>
                        <p><b>Topic: </b>Chinese Talent Assessment and Development: Where We Stand and The Way We Can Go</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=93"><b>Chaoming Liu, Ph.D.,</b> Professor, Department of Psychology at Fu Jen Catholic
University</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>The purpose of this keynote speech is to facilitate the contexts of Chinese Talent Assessment and Development, and to share the practical experience and future thoughts with all participants. The speaker will elaborate the intention and structure of speech based on his academic and practical contexts: 
                          <br><b>· </b>Reviews on the Milestones of Chinese Talent Assessment and Development.
                          <br><b>· </b>AC and leadership development in current Chinese societies.
                          <br><b>· </b>Insights for the future.
                          </p>
                        </span>
                      </div>
                    </li>
                  </ul>
                  <h2>Postmeridian of November 13th</h2>
                  <h3>Concurrent Session A-CHO 100 Workshop</h3>
                  <h6>Best Practices of Talent Assessment and Development in China</h6>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/sy.png" alt="">
                        </div>
                      </div> 
                      <div class="media-body">
                          <p><b>13:30-13:35</b></p> 
                          <p><b> Host Opening Remarks Remarks</b></p> 
                          <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=12"><b>Eva Shen,</b> Country HR Head, Honeywell (China) Co., Ltd.</a></p> 
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/xuf.png" alt="">
                        </div>
                      </div> 
                      <div class="media-body">
                        <p><b>13:35-14:15</b></p> 
                        <p><b>Topic: </b>The Soar of Eagle - Sharing of TCL Senior Executives Training Program</p> 
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=91"><b>Fang Xu,</b> Co-Chairman of CHO100, Executive Principal of TCL University</a></p> 
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>Eagles Development System is TCL's well-renowned talent training system. The eagle has become a symbol and totem of TCL's spirit of continuous self-reform, which is closely related to TCL's strategic cultural change. 
                          <br><b>· </b>The origin of eagle: the nirvana from the globalization dilemma.
                          <br><b>· </b>The Selection of Eagle: Make the Right Choice before the Development.
                          <br><b>· </b>The Experiences of Eagle: To shoulder on heavier responsibilities, it's always to keep the feet on the ground, to tackle the difficulties and be self-disciplined. 
                          <br><b>· </b>The Soaring of Eagle: The best cultivation is to appoint the trained ones.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div><img src="http://static.hrflag.com/img/speakers/ddi/wj.png" alt=""></div>
                      </div> 
                      <div class="media-body">
                        <p><b>14:15-14:55</b></p> 
                        <p><b>Topic: </b>Talents Assessment’s Role in Leadership Development</p> 
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=15"><b>Jasmine Wu,</b> HRVP Greater China, Air Liquide</a></p> 
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>How important is talent assessment? Is it universalistic and objective?
                          <br><b>· </b>Practices Air Liquide use to assess and assist talent and leadership identification and development, what are the results, confusions and why. 
                          <br><b>· </b>Facing future and AI, a wish list to talent assessment, and the industry on bringing us to the future. 
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div><img src="http://static.hrflag.com/img/speakers/ddi/cmfrank.png" alt=""></div>
                      </div> 
                      <div class="media-body">
                        <p><b>14:55-15:35</b></p> 
                        <p><b>Topic: </b>Team Climate Activates the Organizational Capability</p> 
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=2"><b>Frank Chen, Ph.D.,</b> CHRO, Thyssenkrupp Elevator China</a></p> 
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>Good leaders can create an excellent organizational atmosphere, and it is critical to create a healthy environment for the talent. With the vision to drive talent, talent to drive strategy, there will be a covenant of the team to win in the long term.
                          <br><b>· </b>Leadership development approach focusing on team climate.
                          <br><b>· </b>Leadership development approach – Begin with the end in mind.
                          </p>
                        </span>
                      </div>
                    </li> 
                    <li>
                      <div class="media-object">
                        <div><img src="http://static.hrflag.com/img/speakers/ddi/wm.png" alt=""></div>
                      </div> 
                      <div class="media-body">
                        <p><b>15:55-16:35</b></p> 
                        <p><b>Topic: </b>Practice of Business-driven Talent Portrait Construction and Talent Assessment & Development</p> 
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=14"><b>Mei Wei, Ph.D.,</b> VP, Zhejiang Geely Holding Group</a></p> 
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                        <p>In the context of the transformation of the times and Geely's strategic transformation from traditional automobile companies to global innovative enterprises, Geely human resources reconstructs the talents management model which focuses on talents strategy, talents empowering and talents experience. The construction of Geely talents portraits provide a foundation of talents management strategy which will be beneficial to talents identify and develop accurately.
                        <br><b>· </b>Introducing the construction of talent portraits in the context of business drivers.
                        <br><b>· </b>Introducing the status of Geely talent assessment.
                        <br><b>· </b>Sharing the Geely Talent Evaluation Practice Case.
                        </p>
                        </span>
                      </div>
                    </li> 
                    <li class="noimg">
                      <div class="media-object">
                        <div>
                          <img src="" alt="">
                        </div>
                      </div> 
                      <div class="media-body">
                        <p><b>16:35-17:50</b></p> 
                        <p><b>Panel: Best Practices of Talent Assessment and Development in China</b></p> 
                        <div class="imgs">
                          <img src="http://static.hrflag.com/img/speakers/ddi/sy.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/gmf.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/nz.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/zjd.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/xuf.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/wj.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/cmfrank.png" alt="">
                          <img src="http://static.hrflag.com/img/speakers/ddi/wm.png" alt="">
                        </div>
                        <p><b>Host: </b><b>Eva Shen,</b> Country HR Head, Honeywell (China) Co., Ltd.</p> 
                        <p><b>Panelists: </b><b>Meifeng Guo,</b> Director, Human Resources Dept.,
Phoenix Contact (China) Holding Co., Ltd.</p> 
                        <div class="ens">
                          <p><b>Jenny Ni,</b> HR Director, Dow China</p> 
                          <p><b>Jide Zhao,</b> HR Director of Wanhua Chemical, Executive Dean of Wanhua University</p> 
                          <p><b>Chris Xu,</b> Co-Chairman of CHO 100, Executive President of TCL University</p> 
                          <p><b>Jasmine Wu,</b> HRVP, Air Liquide (China) Holding Co., Ltd.</p> 
                          <p><b>Frank Chen, Ph.D.,</b> CHRO, Thyssenkrupp Elevator (China)</p>
                          <p><b>Mei Wei, Ph.D.,</b> VP, Zhejiang Geely Holding Group Co., Ltd.</p>
                        </div>
                      </div>
                    </li> 
                  </ul>
                  <h3>Concurrent Session B</h3>
                  <h3>Seminar of Best AC Practices in Government Sectors</h3>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:30 - 13:40</b></p>
                        <p><b> Host Opening Remarks Remarks:</b></p>
                        <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=81"><b>William C. Byham, Ph.D.,</b> Co-Founder and Executive Chairman, DDI</a></p>
                      </div>
                    </li>
                    <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Svetlana.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>Topic: </b>The Assessment Technologies Used at the Olympic Games in Sochi and the Impact</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=77"><b>Svetlana Simonenko, Ph.D.,</b> Managing Partner of Detech Group, Russia</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                          <p>Limited experience of organizing and holding Large international events and no volunteer culture became the main challenges for Olympic and Paralympic Games in Feb and March 2014. There was the objective – to attract, select, train, mobilize 70,000 motivated people - very diverse team – from all over Russia. That is why the Organizing Committee chose the critical “5 right” approach - right people, right time, right skills, right job, right attitude. </p>
                          </span>
                        </div>
                      </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/Clara Chua.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>14:30 - 15:10</b></p>
                        <p><b>Topic: </b>Finding the Real Deal: Exploring the Personality Profles of Future Leaders in an Assessment Center</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=73"><b>Clara Yi Xin Chua,</b> Psychologist, Ministry of Defence (MINDEF) Singapore</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>One of the ways in which the Singapore military select future leaders is by assessing recruits’ suitability to become officers through an assessment center - Situational Test (SITEST). SITEST is an assessment center designed to test recruits’ leadership potential by putting them through realistic simulations. 
                          <br><b>· </b>Explore the personality profiles of future leaders selected through an assessment center.
                          <br><b>· </b>Examine the short and long term implications of lower levels of diversity of leaders in an organization from a system perspective.
                          <br><b>· </b>Discuss about the measures that can be taken in an organization to increase diversity.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/gxd.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>15:20 - 16:00</b></p>
                        <p><b>Topic: </b>The Exploration & Refection of Leadership Assessment Center Practices for Beijing City Government</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=76"><b>Xiangdong Gu, Ph.D.,</b> Research Associate & R&D Head, Beijing Leader Assessment Service Center</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Review the development process of competitive selection of leading cadres, and analyze the problems and challenges in the practice of cadre assessment.
                          <br><b>· </b>Introduce the development history of assessment technology for leading cadres for more than 20 years, with emphasis on the construction, revision and application of assessment system for leading talents.
                          <br><b>· </b>Reflect on cadre assessment practice, look into the future and Clear direction.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/sihui.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>16:10 - 16:50</b></p>
                        <p><b>Topic: </b>Assessment Center in the Singapore Police Force</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=79"><b>Si Hui Ko,</b> Lead Psychologist, Singapore Police Force</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>In the Singapore Police Force (SPF), the cost of placing an unsuitable officer in key leadership roles has severe consequences given the complexity of modern policing operations. One of the key leadership positions that is critical to effective operations in the SPF are those in middle-manager positions. In order to ensure that suitable officers take up this position, an AC was developed for this selection and assesses officers based on the SPF Leadership Competency Framework. This sharing focuses on the use and value of the ACCO as an assessment resource in supporting SPF management’s decisions. </p>
                        </span>
                      </div>
                    </li>
                  </ul>
                  <h3>Concurrent Session C</h3>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/zy.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:30 - 13:40</b></p>
                        <p><b> Host Opening Remarks Remarks: </b></p>
                        <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=19"><b>Olivia Zhao, </b>HRVP, Autoliv China</a></p>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/pqy.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:40 - 14:20</b></p>
                        <p><b>Topic: </b>The Power of Matching Leaders to Their Challenges</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=59"><b>Chan Yung Phang,</b> Principal Consultant, SHL China</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>To gain insight into how to best resolve this disconnect between volatile work environments and static leadership strategies, SHL conducted one of the largest and most comprehensive leadership research studies in more than 25 years. SHL collected information about leader performance on the job and delved in depth to understand how leader roles differ. SHL also collected information on more than 60 aspects of the work environment, from team dynamics to organizational culture to industry conditions. 
                          <br><b>· </b>SHL’s Innovative Insight in Leader Assessment.
                          <br><b>· </b>SHL Cutting-edge Leader Edge Solution.
                          <br><b>· </b>Case Sharing.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/zy.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>14:30 - 15:10</b></p>
                        <p><b>Topic: </b>Case Sharing: Identifying Innovation DNA Among Talents</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=19"><b>Olivia Zhao,</b> HRVP, Autoliv China</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p><p>The future competition of enterprises in the digital era is ultimately the competition of efficiency. How to make a multinational company with a perfect system break through the tradition to innovate and evolve with the times, to become agile, to create innovative DNA, to give new vitality, become more and more critical.
                          <br><b>· </b>The talent portrait with innovative DNA.
                          <br><b>· </b>The main points and challenges of identifying Innovation Team DNA.
                          <br><b>· </b>The small-scale success of agile organizations – practices of innovative agile team operations.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/jiq.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>15:20 - 16:00</b></p>
                        <p><b>Topic: </b>Empowerment: Establishing Industry Talent Standards, Building an all-win Ecosystem</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=7"><b>Ada Ji,</b> Executive Dean, Wyeth Business School, Wyeth China</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Sharing of the Development White Paper of New Consumer-Driven Partnership for Maternal and Child Store.
                          <br><b>· </b>A solution for talent development based on the data of assessment center. 
                          <br><b>· </b>Best practices of talent development based on assessment.
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/xf.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>16:10 - 16:50</b></p>
                        <p><b>Topic: </b>Ten Practices for Enterprises to Build the Talent Supply Chain</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=69"><b>Belcome Xu, Ph. D.,</b> Founder & CEO of TaleBase</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Talent Supply Chain is built to achieve sustainable high-performance balance of the organization.
                          <br><b>· </b>The risk of personnel redundancy is higher than that of personnel shortage.
                          <br><b>· </b>Decomposition, sorting out and combination of capabilities are the key to build Talent Supply Chain.
                          <br><b>· </b>Choosing is more important than cultivating. 
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/gxl.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>17:00 - 17:40</b></p>
                        <p><b>Topic: </b>Combining Business Simulation Training Programs with AC in a Pharm Company: Method and Efectiveness</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=43"><b>Xile Gao,</b> R&D Director, Aceman Group Consulting</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Sharing the case of Business simulation training program combined with AC in appraisal of senior managers.
                        <br><b>· </b>Behavioral observations in business simulation training program had high validity and effectiveness in classifying competencies of senior managers.
                        <br><b>· </b>Reasons are given to adopting business simulation training program in AC design and application for senior managers.
                        </p>
                        </span>
                      </div>
                    </li>
                  </ul>
                  <h3>Concurrent Session D</h3>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/zyc.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:30 - 13:40</b></p>
                        <p><b> Host Opening Remarks Remarks: </b></p>
                        <p><b>Andrew Chu,</b> Managing Director, DDI North China</p>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/thonton.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:40 - 14:20</b></p>
                        <p><b>Topic: </b>Who Do You Believe? Combining Theory, Research, and Practice to Know What Really Works!</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=22"><b>George C. Thornton III, Ph.D.,</b> Professor Emeritus, Colorado State University, United States</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>The presentation summarizes the best sources of information regarding theory, research, and practice on the AC method, and provides a list of practical implications and recommendations derived from our preferred epistemology, namely where there is a convergence of theory, research, and practice. In our view, he best way to design and implement an AC is to have a combination of sound theory of the processes, empirical research evidence, and examples of practical applications that have been evaluated in multiple organizations. The presentation concludes with a brief illustration of how our model of knowing applies to other HRM interventions.</p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/ygg.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>14:30 - 15:10</b></p>
                        <p><b>Topic: </b>The Challenges and Opportunities of AC & DC in China</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=34"><b>Gonggu Yan, Ph.D.,</b> Associate Professor, Faculty of Psychology, Beijing Normal University</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>In this presentation, the short history of assessment center in China will be introduced at first. Secondly, the main uses of AC and DAC are showed with examples. Two new simulation exercises we developed will be introduced as well. Finally, the Chances and challenges are summarized both on theoretical studies and practices. </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/xxy.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>15:20 - 16:00</b></p>
                        <p><b>Topic: </b>Meta Leadership: A Methodology of Leadership Assessment and Development Based on
Psychobehavioral Science and Experiential Learning</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=33"><b>Xiaoyong Xu, Ph.D.,</b> Professor, Faculty of Psychology, Beijing Normal University</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>In recent years, many business school students, entrepreneurs and business leaders, go to the Gobi, deserts, forests and other challenging environments to genuinely recognize, experience and self-reflect, with the hope of leadership development. 
                          <br>This methodology of leadership assessment and development based on psychobehavioral science and deep experiential learning is defined as Meta Leadership by NCCL. This presentation will share the research findings of NCCL and JLAD over the past three years related to Meta leadership. 
                          </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/zk.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>16:10 - 16:50</b></p>
                        <p><b>Topic: </b>Leadership Competency Assessment and Leadership Development Based on Charisma Personality</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=35"><b>Kai Zhang, Ph.D.,</b> Professor, School of Business, Renmin University of China</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>Based on a new understanding of human nature and the central role of common goals in leadership formation, this presentation begins with exploring a leader's charismatic personality and rethinking and integrating the role of a leader's characteristics, behaviors, values, and abilities in leadership formation.
                        <br><b>· </b>Leadership charm and charismatic personality.
                        <br><b>· </b>The structure and measurement of charismatic personality.
                        <br><b>· </b>Leadership quality evaluation and leadership development based on charismatic personality.
                        </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/lzh.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>17:00 - 17:40</b></p>
                        <p><b>Topic: </b>Leadership Development in College: A Case Study Based on ACDC Approach</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=26"><b>Jyh-Hong Lee, Ph.D.,</b> Associate Professor, Department of Psychology, Asia University</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Summary of the insights and practices on leadership education at university.
                        <br><b>· </b>Brief history and current situation of the creative leadership center at Asia University. 
                        <br><b>· </b>The leadership education at university as the foundation and core for long-term leadership development.
                        </p>
                        </span>
                      </div>
                    </li>
                  </ul>
                  <h3>Concurrent Session E</h3>
                  <ul>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/wmr.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:30 - 13:40</b></p>
                        <p><b> Host Opening Remarks: </b></p>
                        <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=68"><b>May Wei,</b> Head of Talent & Rewards Consulting Services, Willis Towers Watson Taiwan</a></p>
                      </div>
                    </li>
                    <li class="noimg">
                      <div class="media-object">
                        <div>
                          <img src="" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>13:40 - 14:20</b></p>
                        <p><b>Topic: </b>Talent Management Strategy and Best Practice in the Digital Era</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=68"><b>May Wei,</b> Head of Talent & Rewards Consulting Services, Willis Towers Watson Taiwan</a></p>
                        <span class="flexspan">
                        <p><b>Introduction：</b></p>
                        <p>To solve the talent problem in the digital era, Willis Towers Watson conducted an in-depth study and brought forward the Six “Right” Solution. This presentation will introduce the new thinking of organization innovation, the critical competencies and development of future leaders, and how to build digital talent pool and best practices related to this.</p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/dxg.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>14:30 - 15:10</b></p>
                        <p><b>Topic: </b>What do You Do with Assessment Center Data? Best Practices of Talent Development Based on
Assessment Center Results</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=42"><b>Xiao-guang Dong,</b> GM, REC Consulting Co., Ltd.</a></p>
                        <span class="flexspan">
                        <p><b>Introduction：</b></p>
                        <p>What does the data and index based on assessment center mean? How can we leverage the data for development? This presentation will introduce the scale and feedback of AC, and discuss how to develop the competence in a Post Assessment Development workshop.</p>

                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/lws.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>15:20 - 16:00</b></p>
                        <p><b>Topic: </b>Behavior Transformation and Project Measurement</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=85"><b>Louis Liu,</b> GM, Louis Development</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p><b>· </b>Best practice of leadership development and 3 typical challenges.
                        <br><b>· </b>Challenge in behavior change, and solutions with mobile internet technology.
                        <br><b>· </b>Behavior measurement challenges of leadership development projects.
                        <br><b>· </b>Promotion and selection decision after leadership development project. 
                        </p>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div class="media-object">
                        <div>
                          <img src="http://static.hrflag.com/img/speakers/ddi/alex.png" alt="">
                        </div>
                      </div>
                      <div class="media-body">
                        <p><b>16:10 - 16:50</b></p>
                        <p><b>Topic: </b>The Road of Testing Development in China under an International Scope</p>
                        <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=65"><b>Alex Tong,</b> VP, ATA</a></p>
                        <span class="flexspan">
                          <p><b>Introduction：</b></p>
                          <p>This presentation will introduce the rapid growth and technology application of the Chinese testing market, and analyze the testing data in the past 20 years, to explore the AI development and future trends of the Chinese testing market.</p>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Nov 14th" name="third">
                <div class="media">
                    <h2>Antemeridian of 14th November</h2>
                    <h3>Concurrent Session A</h3>
                    <ul>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/panx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:10</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Grace Pan,</b> Senior Consultant, DDI China</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/wul.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:10 - 09:50</b></p>
                          <p><b>Topic: </b>CSOT Talent Development</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=21"><b>Grace Wu,</b> CSOT HR SVP, CSOT College Dean</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>After continuous exploration, CSOT has built an endogenous talent development system based on AC, aiming to explore and develop more young people with potential.
                          <br><b>· </b>Construct a talent development structure based on business requests.
                          <br><b>· </b>Build & apply CSOT’s assessment center.
                          <br><b>· </b>How to polish our TD in the future.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/ario.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 - 10:40</b></p>
                          <p><b>Topic: </b>Utilizing AC Left Over: Initiatives to be Data-Driven Assessment Center</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=39"><b>Ario Bimo,</b> Head of Assessment Centers, Daya Dimensi, Indonesia</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>This presentation covers the initiatives of Daya Dimensi Indonesia on its journey to become a data-driven assessment center, starting from analyzing numerous data archived to draw meaningful descriptive and correlated statistic implications.
                          <br><b>· </b>Becoming a data-driven assessment center.
                          <br><b>· </b>Case study of converting data sets into useful information.
                          <br><b>· </b>Collaboration between AC and DC.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li class="twospeakers">
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/mangal.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:50 - 11:30</b></p>
                          <p><b>Topic: </b>Beyond Assessment Centers: From Discovery to Development</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=54"><b>Mangal Dhuri,</b> Principal Consultant, Cerebrus Consultants, India</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Assessment process itself can become the start of a Development Journey and the speakers’ experience of creating such learning experience for their clients.
                          <br><b>· </b>Their experiments with different models to move beyond assessment and create meaningful development journeys for their clients. 
                          <br><b>· </b>Learnings from the experiments and the tools they have developed to enable this journey. 
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Mark Busine.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:40 - 12:20</b></p>
                          <p><b>Topic: </b>The Dynamic Duo: Assessment and Development</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=55"><b>Mark Busine,</b> VP, Product Management, DDI</a></p>
                         <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The historical relationship between assessment centers and development with specific reference to DDI’s 50 years of experience, practice and research
                            <br><b>· </b>The advantages of integrating assessment centers and development in today’s business and leadership context.
                            <br><b>· </b>Recommendations for how to maximize the integration of assessment centers and development.
                            </p>
                         </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session B</h3>
                    <ul>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lhy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:10</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=49"><b>Huiyuan Li,</b> GM, TDS Group, DDI Greater China</a></p>
                        </div>
                      </li>
                      <li class="noimg">
                        <div class="media-object">
                          <div>
                            <img src="" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:10 - 09:50</b></p>
                          <p><b>Topic: </b>High Resolution Leadership in Great China – Explore the Future of Executive Leadership</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=49"><b>Huiyuan Li, GM,</b> TDS Group, DDI Greater China</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Analysis of DDI’s 20 years of executive AC data in Greater China.
                            <br><b>· </b>Analysis of the impact of culture and economic development on leadership by comparing the data of executive leadership in Greater China and worldwide. 
                            <br><b>· </b>Forecast the future portrait of Chinese leaders.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Vincent.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 - 10:40</b></p>
                          <p><b>Topic: </b>Organization and Talents in Digital Transformation Era</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=99"><b>Vincent Song,</b> Consulting Director, Aon Hewitt</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In the digital era, how can we effectively leverage all kinds of organization data to implement the strategy of an enterprise? How can we attract and develop digital talent in the future?
                          <br><b>· </b>The scenarios of data in the context of digitalization and case study.
                          <br><b>· </b>The key steps to building digital capabilities and the features of digital talent.
                          <br><b>· </b>How to attract and assess the new-gen in the digital era.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/gum.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:50 - 11:30</b></p>
                          <p><b>Topic: </b>Power of Data under Strategic Transformation</p>
                          <p><b>Speaker：</b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=20"><b>Ming Gu,</b> GM, Big Data Service Platform of Health, Yunnan Baiyao Group</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Learnings from building an online marketing team by using data.
                          <br><b>· </b>The construction of data system construction is a fundamental skill for the human resource department.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/tym.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:40 - 12:20</b></p>
                          <p><b>Topic: </b>The Start-up Enterprise in 0-1 Stage, the Application of Data in Talents, Culture
and Organization</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=44"><b>Terence Tian,</b> VP, KNX China</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The portrait of talent in start-ups.
                          <br><b>· </b>The connection between talent and culture in start-ups.
                          <br><b>· </b>The characteristics of organization data in start-ups.
                          </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session C</h3>
                    <ul>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/dxx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:10</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Sharon Deng,</b> Senior Consultant, DDI China</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zjd.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:10 - 09:50</b></p>
                          <p><b>Topic:</b>The Development of Excellent Talent Starts with Assessment</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=18"><b>Jide Zhao,</b> HR Director of Wanhua Chemical, Executive Dean of Wanhua University</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>The speaker will introduce the strategic planning for talent development by the Human Resources Department of Wanhua Chemical. Before implementing the training program, they use assessment tools to help senior leaders understand the teams and improve self-awareness, deepen the understanding of self-development. Besides, they create development plans for the teams according to the leaders' common characteristics and develop the leaders based on individual personalities.</p>
                          </span>
                        </div>
                      </li>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Pieter Bronkhorst.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 - 10:40</b></p>
                          <p><b>Topic: </b>Shoot Out! What Predicts Leadership Potential Best? Assessment Centers, Cognitive
Tests, or Personality Tests? The Latest Research on the Topic!!</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=61"><b>Pieter Bronkhorst, Ph.D.,</b> Founder, Evalex Talent Solutions, South Africa</a></p>
                        </div>
                      </li>
                      <li class="twospeakers">
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/david.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:50 - 11:30</b></p>
                          <p><b>Topic: </b>Where’s the Fire! Assessment Center Application in the US Fire Service</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=74"><b>David Slivinski,</b> Program Director, Assessment & Consulting Services, Illinois Fire Chiefs
Association, United States</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Hundreds of thousands of times throughout a single day throughout the world, people count on their fire departments and rescue departments to provide fire suppression and life-saving emergency medical assistance. This presentation will look at several assessment practices designed for American fire and emergency services.
                            <br><b>· </b>Overview of the American Fire Service assessment center – what’s Involved.
                            <br><b>· </b>Performance and behavioral dimensions supporting solid emergency leadership.
                            <br><b>· </b>A simulated scenario of fireground decision - making for leadership.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/khd.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:40 - 12:20</b></p>
                          <p><b>Topic: </b>Unlock Talents: Elevating the Benchmarks and Efciencies of Talent Management</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=45"><b>Richard Kang,</b> GM, Clavis Consultants</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The roles of behavioral and cognitive assessments.
                            <br><b>· </b>Scientific and objective analysis of job requirements and modeling.
                            <br><b>· </b>The organic combination of business objectives, corporate culture, recruitment & promotion and human resource management to improve the efficiency of recruitment, training and retention. 
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session D</h3>
                    <ul>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lf.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:10</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=48"><b>Frank Li, Ph.D.,</b> Founder of Leadership Grammar Model</a></p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/朱伟正.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:10 - 09:50</b></p>
                          <p><b>Topic: </b>The Trends of Training and Talent Development in Enterprises</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=80"><b>Weizheng Zhu,</b> President, Training Magazine</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Becoming a business partner by combining training, learning, performance and business results.
                          <br><b>· </b>Corporate universities have become the key to empowering people.
                          <br><b>· </b>The innovation of learning in the digital era.
                          <br><b>· </b>Leadership development and executive training are still the core of learning and development.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lf.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 - 10:40</b></p>
                          <p><b>Topic: </b>Less is More：A Minimalist Approach to the Assessment of Leadership Potential</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=48"><b>Frank Li, Ph.D.,</b> Founder of Leadership Grammar Model</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The fewer dimensions, the higher validity. The DICE (Drive, Intelligence, Courage, and Empathy) model of high-potential leaders. 
                            <br><b>· </b>How to measure DICE most efficiently and most effectively. 
                            <br><b>· </b>If there is only 1 hour, what should an AC matrix look like? 
                            <br>-	A single-item IQ （g factor） test 
                            <br>-	Immediately scorable interview 
                            <br>-	Demo of a miniature behavioral simulation 
                            </p>
                          </span>
                        </div>
                      </li>
                      <li class="twospeakers">
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/黄一峰.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:50 - 11:30</b></p>
                          <p><b>Topic: </b>Developing a Leaderless Group Discussion (LGD) Assessment Mechanisms
through an AI System: A Pilot Study</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=25"><b>Irving Huang, Ph.D.,</b> Associate Professor, Department of Public Administration, Tamkang University</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>It has become more popular to apply new technology in assessment center for better quality of assessment. How to build an assessment mechanism through the artificial intelligence (AI) system will be a new trend of AC applications. The AI system can start to learn the assessment criteria from fewer samples and gradually to expand the competences for assessment when samples increased. This paper aims to explore the pilot application process of AI and how to set up a LGD assessment mechanism that can conduct assessment without assessors.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/CathyCao.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:40 - 12:20</b></p>
                          <p><b>Topic: </b>Digital Ready Talent & Leadership</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=40"><b>Cathy Cao,</b> Managing Consultant and Head of YSC China</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Digital assessment technology is not to replace but to augment what humans do in order to manage an unpredictable future. There are some tasks people can automate whilst others, such as navigating ambiguity and motivational leadership, will be more human-focused.
                            <br><b>· </b>Technology is changing our lives.
                            <br><b>· </b>Navigating the maze of opportunity.
                            <br><b>· </b>Leading to shape the future. 
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session E</h3>
                    <ul>
                       <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lkg.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:10</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=51"><b>Carl Liang, Ph.D.,</b> Managing Director, C&D Management Consulting</a></p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/alan.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:10 - 09:50</b></p>
                          <p><b>Topic: </b>Using Personality Tasks to Boost the Validity of Assessment Centers</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=38"><b>Alan Howard,</b> Director, Quest Partnerships, Ltd., United Kingdom</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Using personality assessment as part of assessment center.
                            <br><b>· </b>Is personality relevant when assessing competencies?
                            <br><b>· </b>Common factors reducing the validity of assessment centers & how personality assessment can help.
                            <br><b>· </b>Common problems with personality questionnaires.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/KristaPederson.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:00 - 10:40</b></p>
                          <p><b>Topic: </b>Assessing Global Talent: Using Personality Assessment for Talent across Asia and the Globe</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=47"><b>Krista Pederson,</b> Director, Asia Pacifc Business Development, Hogan Assessment Systemss</a></p>
                          <span class="flexspan">
                              <p><b>Introduction：</b></p>
                              <p><b>· </b>Personality Assessment is one of the best ways to select and develop talent across countries, specifically when best practices are used for applying the assessment globally, including accuracy and context. 
                            <br><b>· </b>The personalities of leaders and talent differ across different countries, especially in countries across Asia. 
                            <br><b>· </b>Understanding those differences will help companies develop more fair and accurate selection and development criteria.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li class="twospeakers">
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lkg.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:50 - 11:30</b></p>
                          <p><b>Topic: </b>Developing Leaders with Personality-based Interventions: Practices of Chinese Enterprises</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=51"><b>Carl Liang, Ph.D.,</b> Managing Director, C&D Management Consulting</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The relationship between personality and leadership effectiveness in Chinese organizations will be reviewed. 
                          <br><b>· </b>Assessing personality traits plays a signiﬁcant role in leader development. 
                          <br><b>· </b>A variety of Chinese cases with a combination of leader development intervention based on personality assessment will be shared.  
                          </p>
                          </span>
                        </div>
                      </li>
                      <li class="twospeakers">
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/wy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:40 - 12:20</b></p>
                          <p><b>Topic: </b>Encompass the Best of East and West: Development of a Cultural Agility and Competency
Prediction Solution</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=67"><b>Doris (Yang) Wang,</b> Senior Consultant, Cubiks</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The successful adaptation of a well-established personality questionnaire for use in China. 
                          <br><b>· </b>The development of a Cultural Agility Model – the overarching potential of an individual to perform effectively in the Chinese business environment through insight, influence, and implementation. 
                          <br><b>· </b>The line manager and assessor friendly competency-based reporting built on a well-validated hierarchical competency framework. 
                          </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h2>Postmeridian of 14th November</h2>
                    <h3>Concurrent Session A - DAC Workshop</h3>
                    <h6>Developmental Assessment Centers: BOTH Behavioral Assessment AND Behavioral Training</h6>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/thonton.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 13:45</b></p>
                          <p><b>Host Opening Remarks:</b></p>
                          <p><a href="https://assessmentcenters.hrflag.com/brief_en?detail=22"><b>George C. Thornton III, Ph.D.,</b> Professor Emeritus, Colorado State University, United States</a></p>
                        </div>
                      </li>
                      <li class="noimg">
                        <div class="media-object">
                          <div>
                            <img src="" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:45 - 14:15</b></p>
                          <p><b>Topic: </b>Model and Principles for Developmental Assessment Centers</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=22"><b>George C. Thornton III, Ph.D.,</b> Emeritus Professor, Colorado State University, United States</a></p>
                         <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Model of Developmental Assessment Center.
                          <br><b>· </b>Principles underlying features of model.
                          <br><b>· </b>Evidence of effectiveness. 
                          </p>
                         </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/mash.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:15 - 15:00</b></p>
                          <p><b>Topic:</b>38 Years of Experience in Giving Assessment Center Participants Feedback on Their Behavior in the
Middle of Their Assessment Center</p>
                          <p><b>Speaker:</b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=57"><b>Masahiro Toyhama,</b> President, MSC, Japan</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In 1972, MSC ran the first assessment centers in Japan and had been the major company specializing in assessment centers since that time. A unique feature of the MSC assessment center is that in group discussion-type exercises, participants are divided into teams and the teams observe each other, and give each other feedback on their performance. Besides, MSC combines assessment with training, and it is a good fit for Japanese culture. </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/naghi.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:10 - 15:35</b></p>
                          <p><b>Topic: </b>Leader Developmental Assessment Center: Empirical Testing</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=31"><b>Naghi Radi Afsouran, Ph.D.,</b> Assistant Professor, University of Guilan, Iran</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>The aim of this study is to validate empirically the effectiveness of Leader Developmental Assessment Center (LDAC). An experimental design with pre-test and post-test was used. The results showed that the training content and design of LDAC have been valid in all three parts of design, validity and delivery. </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Sandra.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:35 - 16:10</b></p>
                          <p><b>Topic:</b>Succession Development Programme and Preliminary Findings</p>
                          <p><b>Speaker:</b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=63"><b>Sandra Schlebusch,</b> Managing Director, Lemasa, South Africa</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>What makes a Coaching Development Center unique.a1
                            <br><b>· </b>The importance of well-structured post-center activities to change behavior.
                            <br><b>· </b>The importance of appropriately embedding a Development Assessment Centre within other People oriented processes. 
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/martin.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>Topic: </b>Development Centers That Last</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=56"><b>Martin Lanik, Ph.D.,</b> CEO, Pinsight, United States</a></p>
                          <span class="flexspan">
                              <p><b>Introduction：</b></p>
                              <p><b>· </b>How digital transformation is impacting AC practice.
                            <br><b>· </b>Considerations when moving ACs online.
                            <br><b>· </b>Using technology to aid in behavioral change. 
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session B</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/cjp.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 14:40</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Bridget Cao,</b> Consulting Director, DDI East China</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>Topic: </b>Gender, Race, Age, Religion, Country of Origin, Sexual Orientation, and Other Possible
Biases in Assessment Centers</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=36"><b>William C. Byham, Ph.D.,</b> Co-Founder and Executive Chairman, DDI</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Anytime humans are asked to make decisions or take action, there is an opportunity for unintended bias to affect their judgments.  In this session, the speaker will address several important issues and questions including: Are organizations systematically tracking assessor decisions to recognize and minimize unintended bias in their assessment centers? How should they check for bias and how often? What is the relationship between different assessor training methods and bias? What about length of assessor training and bias? Are professional assessors more or less prone to bias? Does bias increase or decrease with experience? Do some assessors develop biases over time as an assessor? What is the impact of an assessor observing a person in several assessment center exercises? What actions can organizations take if bias is discovered? </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/anna.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>Topic: </b>Leadership Competencies</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=23"><b>Anna Baczynska, Ph.D.,</b> Assistant Professor, Kozminski University, Poland</a></p>
                         <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>New view of leadership competencies which are useful for many different businesses.
                            <br><b>· </b>Model which could be useful for development of mangers who would like to become a leader.
                            <br><b>· </b>Difference between managers and leaders on competencie’s field.
                            </p>
                         </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Martin_Kleinmann.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>Topic: </b>Assessment Centers: A Conceptual Review</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=30"><b>Martin Kleinmann, Ph.D.,</b> Full Professor, Department of Psychology, University of Zurich, Switzerland</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Overview of conceptual models and empirical research in assessment center research.
                            <br><b>· </b>Practical implications for conducting assessment centers.
                            <br><b>· </b>Guideline for future research.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/czl.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>Topic: </b>Guidelines and Ethical Considerations for Assessment Center Operations:
How Organizations Can Beneft from the Guidelines</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=41"><b>Gary Chen, Ph.D.,</b> President and Chief Consultant, East-West Management</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Describe the processes of forming the committee in China to create the first Chinese version of guidelines for AC operations. 
                          <br><b>· </b>Describe what key differences between Chinese guidelines and International Taskforce English guidelines are, how the differences reflect cultural implications and the trends of the future. 
                          <br><b>· </b>Explain the value of the Chinese guidelines and how to use it to build more effective assessment centers and development centers.
                          </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session C</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zhj.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 14:40</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Vincent Zheng,</b> Senior Consultant, DDI China</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lyt.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>Topic: </b>Open Competition of Senior Executive Based on Leadership Model and AC - Successful
Practice of K Group, a Listed Company Invested by a Central Enterprise</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=50"><b>Oak Y. T. Li,</b> Partner, Talent-Label Management Consulting Shanghai</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Construction of leadership model system for senior management positions in K Group of listed companies with central enterprise background. 
                          <br><b>· </b>Development of AC tools based on the leadership model and design of the selection process.
                          <br><b>· </b>Implementation and effect feedback of open competition project for senior management positions based on AC.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/llx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>Topic: </b>Build up a Talent Recruitment Testing System with Industry Features</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=9"><b>Ellen Liu,</b> HR Director, Samsung Insurance</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The analyses of talent supply chain map
                          <br><b>· </b>The 3D qualification model under the iceberg model
                          <br><b>· </b>The four-guidance-evaluation system of talent recruiting: Competency-oriented, Character-oriented, Culture-oriented, Post-oriented. 
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Young.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>Topic: </b>History of Assessment Center Operations in South Korea over 13 Years</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en/?detail=70"><b>Young-Jae Kim,</b> Senior Research Analyst, Assesta, South Korea</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In 2006, the Korean government initiated the Assessment Center (AC) operations to select and promote middle-level officials to higher-ranked senior executive positions. Since then, the AC method has been spread out from the central government to public enterprises as a sophisticated tool for selecting and promoting personnel. In this presentation, the progress and development of ACs in the Korean government, along with both micro and macro factors incorporated in the AC administrations, will be discussed.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/lcy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>Topic: </b>Application and Development of Talent Assessment Center</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=27"><b>Stanley Lin,</b> Consultant, Talent Assessment & Development Center, Chinese Culture University</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>Business simulation training program can be combined with AC in appraisal of senior managers.
                            <br><b>· </b>Behavioral observations in business simulation training program had high validity and effectiveness in classifying competencies of senior managers.
                            <br><b>· </b>Reasons are given to adopting business simulation training program in AC design and application for senior managers.
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session D</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/ydy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 14:40</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Jenny Yao,</b> Managing Consultant, MD of South China, DDI</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/syh.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>Topic: </b>How Would You Judge If a Talent Has Leadership Potential?</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=96"><b>Yonghua Su, Ph.D.,</b> CEO and Chairman, NormStar</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Traditionally, leaders selection depends much on external standards, such as education level, majors, work experience, past work performance, skill certificates, and so on. However, such standards can hardly meet the needs of the fast-developing environment nowadays. For talent management and especially the construction of talent teams in the enterprises, it is crucial and practically significant to be able to judge whether a person has the potential for a leader. Based on years of research and practical experience in the selection and training of leaders, NormStar has proposed a set of theoretical systems and tools for the evaluation of leaders' potential and leaders selection, which is of great help to lead and manage talent team in the enterprise. 
                            <b>· </b>The meaning of Distinguishing Leadership and Leadership Potential.
                            <br><b>· </b>Application Performance Management (APM) theory and its practical value for leadership potential.
                            <br><b>· </b>How to improve the accuracy of the identification of leadership potential?  
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/sx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>Topic: </b>How Assessment Centers Support Building an Internal Promotion Path: Hi-po Development Case Sharing</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=13"><b>Xia Su,</b> Head of HR Department, Omron China</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>The speaker will share the practice of assessment center in Omron China and how assessment center help to implement Omron’s talent strategy.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/rxq.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>Topic: </b>Assessment and Development for Hi-potential Talents in the Digital Era</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=62"><b>Russ Rao,</b> Partner & Co-founders, Leader’s Gene Consulting</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In the digital era, the traditional way of talent assessment and development has been dramatically challenged. The testing and development of talent are rushing towards the dynamic, agility-oriented direction. How to define and measure a person’s potential nowadays? This presentation will explore what kind of talent we need in the digital era, as well as the testing and development of HiPos.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zxx.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>Topic: </b>Transforming Talent Development</p>
                          <p><b>Speaker: </b><b>Kitty Zhao,</b> Sr Director, HR - Greater China and Talent Management – APAC, Baxter</p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In a VUCA world, the business environment has changed dramatically, new technologies and invisible rivals have emerged, and all industries are experiencing transformation and innovation. More and more organizations are trying to make their business units as agile as possible. Likewise, Baxter has undergone significant organizational and cultural changes over the past three years to build a more agile organization.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/xt.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>17:00 - 17:40</b></p>
                          <p><b>Topic: </b>How AI Enables Talent Evaluation to a New Horizon</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=98"><b>Ting Xiao,</b> Director, Institute of Talent and Organization Department, Liepin</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>With the rise of AI technology, there will be great opportunities in talent evaluation. With the vast amount of information captured by machines and the experience of human experts, AI can quickly learn and form a model. The AI talent assessment can obtain more information than human beings, and analyze the talent more accurately.
                            <b>· </b>The opportunities brought by AI.
                            <br><b>· </b>The path of the implementation.
                            <br><b>· </b>The practice of AI talent evaluation.
                            </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <h3>Concurrent Session E</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/Billy.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:30 - 14:40</b></p>
                          <p><b>Host Opening Remarks: </b></p>
                          <p><b>Billy Sun,</b> Senior Product Manager, DDI Greater China</p>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/mjh.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>13:40 - 14:20</b></p>
                          <p><b>Topic: </b>The Assessment and Development of Hi-Level Talent Recruitment</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=29"><b>Jianhong Ma, Ph.D.,</b> Professor, Department of Psychology and Behavioral Science,
Zhejiang University</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The problems of personality and adaptation of high-end talent introduction process.
                          <br><b>· </b>The adaptation results of high-end talent introduction: integration, combination, separation, and marginalization. Integration is the best status.
                          <br><b>· </b>Combining evaluation and development can realize the effective unification of talent selection and adaptation.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/elise.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>14:30 - 15:10</b></p>
                          <p><b>Topic: </b>How can Neuroscience be Leveraged in Leadership Assessment and Development?</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=72"><b>Elise Zhu,</b> Founder of Center for NeuroEdge Leadership & Organizational Psychologist</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>How has neuroscience been used in assessment, and what might the future look like?
                          <br><b>· </b>How to make more informed and effective assessment decisions: the neuroscience of unconscious biases and how to break them?
                          <br><b>· </b>How can neuroscience help developing better leaders?
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/pj.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>15:20 - 16:00</b></p>
                          <p><b>Topic: </b>From Desert to Oasis: Assessment Centers and Talent Development Practical Application</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=11"><b>Serena Ping,</b> Head of HR, Hilti China , Hilti North Asia E&I</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Hilti has been focusing on talent development and talent pool buildup in Hilti China in the past six years, and talent ratio improved from 12% to 25%, which successfully meets the talent requirement of the company. The strategy and practice of Hilti will be shared, as well as the AC method applied in the talent development program. 
                            <br><b>· </b>Sharing how Hilti develop a talent strategy to support organizational development.
                            <br><b>· </b>Analyzing the four criteria to identify talent in Hilti and the method for AC.
                            <br><b>· </b>Introducing the talent development program in Hilti and the results.
                            </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/xxj.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>16:10 - 16:50</b></p>
                          <p><b>Topic: </b>Cross-cultural Competency Model of Overseas Expatriate Managers: A Qualitative Study on
Chinese MNCs</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=32"><b>Shirley Xu,</b> Associate Professor, School of Management, Fudan University</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>With the development of the Belt and Road Initiative, more Chinese enterprises are going global, and more expatriate managers are active in the international business arena. Whether expatriate managers can adapt to the cross-cultural working environment and successfully complete overseas assignments directly determines the success or failure of the global strategy of Chinese enterprises.
                          <br><b>· </b>Introduce the expatriate managers’ cross-cultural competence model, including the definition of competencies and their behavioral description. 
                          <br><b>· </b>Discover the inter-relationship among the competencies. 
                          <br><b>· </b>Analyze how individual motivational traits (internal drive) and external incentive measures (external drive) complement each other and collectively influence the behaviors of expatriate managers.
                          </p>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
              </el-tab-pane>
              <el-tab-pane label="Nov 15th" name="fourth">
                  <div class="media">
                    <h2>Antemeridian of 15th November</h2>
                    <h3>Keynote Session</h3>
                    <ul>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/hjh.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:00 - 09:40</b></p>
                          <p><b>Topic: </b>Develop Future Leaders</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=6"><b>Jinghua He,</b> Vice Dean, Tencent College</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>In 2004, Tencent went public, while the rapid development of business, the demand for talent is also growing. Tencent invested a lot of resources in succession management, and the program of Flying Dragon emerges at the right moment. At first, the program paid more attention to the training of managers. Since 2009, the company has decided to develop a more accurate training method for managers, so the construction of assessment was put on the agenda. This presentation will share the comprehensive thinking and review of the assessment center at Tencent, summarize the pits that Tencent has stepped on, and also showcase Tencent's achievements, which will serve as a reference for selecting and developing leaders.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/zwg.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>09:40 - 10:20</b></p>
                          <p><b>Topic: </b>Identify the Self-Disruptive Leaders, the Key to Winning in Digital Times</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=71"><b>Wilson Zhang,</b> Senior Client Partner of Korn Ferry, China Managing Director, Korn Ferry Advisory Business</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p>Digital Times makes traditional leadership models Redundant, new kind of future-ready leader required by organizations. Disruption of markets can only be met with the disruption of the leadership approach. In short, it’s the Self-Disruptive Leader companies now need. Through intellectual property-based assessment, KF found that ambiguity tolerance and change agility are good indicators of self-disruptive leaders. The presentation will discuss who has the potential to be the Self-disruptive leader and How to access and identify the Self-disruptive leaders. It’s the key to winning in digital times.</p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/dwb.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>10:20 - 11:00</b></p>
                          <p><b>Topic: </b>Our Path to a High Performing Organization</p>
                          <p><b>Speaker: </b><a href="https://assessmentcenters.hrflag.com/brief_en?detail=3"><b>Webb Ding,</b> President of Fresenius Kabi China</a></p>
                          <span class="flexspan">
                            <p><b>Introduction：</b></p>
                            <p><b>· </b>The talent strategy of Fresenius Kabi.
                          <br><b>· </b>The leadership team of the company.
                          <br><b>· </b>The practice on talent development and organizational competitiveness building.
                          </p>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div class="media-object">
                          <div>
                            <img src="http://static.hrflag.com/img/speakers/ddi/BruceWatt.png" alt="">
                          </div>
                        </div>
                        <div class="media-body">
                          <p><b>11:00 - 11:50</b></p>
                          <p><b>Topic: </b>High-End Talent Strategic Planning in a Business World of Rapid Change</p>
                          <p><b>Speaker: </b><b>Bruce Watt, Ph.D.,</b> VP, DDI</p>
                        </div>
                      </li>
                    </ul>
                  </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <wrapright></wrapright>
        </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
  import homen from '@/components/commn/homen'
  import foot from '@/components/commn/foot'
  import wrapright from '@/components/commn/wrapright'
 export default {
      components:{
        homen,
        foot,
        wrapright
      },
    metaInfo: {
      title: 'agenda - 42nd International Congress on Assessment Center Methods and Developing Leadership Talent',
      meta: [
        {
          name: 'keywords',
          content: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent; Leadership Development Forum'
        },
        {
          name: 'description',
          content: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent will be hold on 13th - 15th Nov, Shanghai Marriott Hotel City Centre'
        }
      ]
    },
      data() {
      return {
        activeName: 'second',
        KeynoteSpeakers:[],
        BusinessLeaders:[],
        CrossBorderExperts:[],
        LeadingProfessionals:[],
        TopScholarsdatas:[],
      }
    },
    methods: {
       handleClick(tab, event) {
        
      },
      toBio(item,id) {
            this.$router.push({ 
                path: '/brief_en', 
                query:{ KeynoteSpeakers:item.name}})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
            },
            toBio1(item,id) {
                this.$router.push({ 
                    path: '/brief_en', 
                    query: { BusinessLeader: item.name }})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
            },
            toBio2(item,id) {
                this.$router.push({ 
                    path: '/brief_en', 
                    query: { CrossBorderExpert: item.name }})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
            },
            toBio3(item,di) {
                this.$router.push({ 
                    path: '/brief_en', 
                    query: { LeadingProfessional: item.name }})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
            },
            toBio4(item,id) {
                this.$router.push({ 
                    path: '/brief_en', 
                    query: { TopScholarsdata: item.name }})//跳转个人简介
                localStorage.detailsList = JSON.stringify(item)
            },
            getBio () {
                this.axios({
                    method: "post",
                    url: "https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=1",
                })
                .then(res=> {
                    console.log(res)
                    this.KeynoteSpeakers = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio1 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=4"
                })
                .then(res=> {
                    this.BusinessLeaders = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio2 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=5"
                })
                .then(res=> {
                    this.CrossBorderExperts = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio3 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=3"
                })
                .then(res=> {
                    this.LeadingProfessionals = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
            getBio4 () {
                this.axios({
                    method: "post",
                    url: " https://form.hrflag.com/WebAPI/HRflag/GetBioInEN?iAre=2"
                })
                .then(res=> {
                    this.TopScholarsdatas = res.data
                })
                .catch(function(error) {
                    console.log(error)
                })
            },
    },
    created() {
          this.getBio ()
          this.getBio1 ()
          this.getBio2 ()
          this.getBio3 ()
          this.getBio4 ()
      }
 }
</script>
<style>
    @import url('../assets/css/inpublic.css');
    table th, table td {
        font-size: 16px;
    }
    .el-table .warning-row {
        background: oldlace;
    }
    .el-table .success-row {
        background: #f0f9eb;
    }
    .el-table--border {
        border: solid 10px #f0f0f0 !important;
    }
    .el-tabs__nav {
      width: 100%;
    }
    .el-tabs__nav .el-tabs__item {
      width: 25%;
      text-align: center;
      padding: 0;
    }
     .el-tabs__active-bar {
      background-color: #e4912b;
      width: 25% !important;
    }
    .el-tabs__item:hover {
      color: #e4912b !important;
      cursor: pointer;
  }
  .el-tabs__item.is-active {
      color: #e4912b !important;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2) {
      padding: 0 !important;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    padding: 0 !important;
  }
  .el-tabs__item {
    font-size: 18px;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__nav {
    background: #f0f0f0;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2) {
    padding: 0 !important;
  }
  @media screen and (max-width:768px) {
    .el-tabs__item {
        font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/agenda_en.vue